import { IMetadata } from '@interfaces/metadata';

import { TFindParams } from '../server/services/metadata';

import { ProxyClient } from './client/ProxyClient';

export const loadMetadata = async (params: TFindParams): Promise<IMetadata> => {
  const { data } = await ProxyClient.post('/metadata', params);

  return data;
};
